export const dataStaticAppVzla = {
  home: {
    shortCutList: [
      {
          'description': 'Folleto Súper Precio',
          'imageURL': 'https://lh3.googleusercontent.com/HQE7DHgyiRBEwsRlr7jaGYkLGh5EA8EI-UW9g7vaqZo_JID6m8mlo2QGFdecAhZaw6wsRccPr5fgx0-UwbBlMj0bZ1AhtQ1b0Lg',
          'redirectURL': '/content/RevistaFarmatodo',
          'idWebSafeShortcut': 'ahZzfm9yYWNsZS1zZXJ2aWNlcy12emxhcjILEghTaG9ydGN1dCIkNGEwMzcwZDQtYTdhNi00ZjM2LTk5MzctNzNhZTlhMDRmNDJmDA',
          'order': 1,
          'modificationDate': '2021-07-27T20:36:30.410Z',
          'status': 'A',
          'idCategory': '0'
      },
      {
          'description': 'Información Coronavirus',
          'imageURL': 'https://lh3.googleusercontent.com/Tg6S0lgKxui2oVdGw__kLRRju1cqfjcOvPFRMDKn9a541_2V8pow3yLJFmAIWiWnytja_EXcxNS0Lq2m-PuXe36Oh199HzPlhzo',
          'redirectURL': 'https://www.farmatodo.com.ve/content/TratamientosEspeciales',
          'idWebSafeShortcut': 'ahZzfm9yYWNsZS1zZXJ2aWNlcy12emxhcjILEghTaG9ydGN1dCIkMWI1ZTQ3YjItNTdjZi00ZDM5LWI3N2QtZjRlYjFjYjQ0ZDFkDA',
          'order': 2,
          'modificationDate': '2021-04-12T21:51:41.848Z',
          'status': 'A',
          'idCategory': '0'
      },
      {
          'description': 'Promoción Moto Regístrate aquí',
          'imageURL': 'https://lh3.googleusercontent.com/s5NDWts65SnHm5Fi80sMwEEXDv8N9Re0pnbETvP1JrtM4ftX2_Do9qqO73RmKbmvw0WlQEjICXB73-2ovSdRRpz2TRb6YUPXitiJHMI6p3PF81TCkw',
          'redirectURL': 'https://www.farmatodo.com.ve/registro',
          'idWebSafeShortcut': 'ahZzfm9yYWNsZS1zZXJ2aWNlcy12emxhcjILEghTaG9ydGN1dCIkYWJkMDIxNTYtZjA5ZC00MmMzLTg4ZTQtNjI1ZDMwY2RiYTExDA',
          'order': 2,
          'modificationDate': '2021-08-23T16:22:14.674Z',
          'status': 'A',
          'idCategory': '0'
      },
      {
          'description': 'Productos Nuevos',
          'imageURL': 'https://lh3.googleusercontent.com/E3RiLcLsla36WWzb57yICdCMz2Kg5CYTUjP_6mwZ9PO5LcimHfTOLM5bWov31Zm4b7TqeM7O6uBULJjuTVjzEQiGvN5Rbo6cAekPAS0dBcRWyOfq',
          'redirectURL': '/marcas/nuevos_productos',
          'idWebSafeShortcut': 'ahZzfm9yYWNsZS1zZXJ2aWNlcy12emxhcjILEghTaG9ydGN1dCIkYmJhMTQ4YjUtN2ZmMy00NDExLWE4M2YtNzVjYmY0NWNhMTIxDA',
          'order': 2,
          'modificationDate': '2021-07-27T20:36:20.813Z',
          'status': 'A',
          'idCategory': '0'
      },
      {
          'description': 'Únete a Farmatodo',
          'imageURL': 'https://lh3.googleusercontent.com/LWEsddoMVby0A05EoTsTM06aRYE8Df84awuk9N4uxA6S4LFnk2-ttJO5DxpmXeCtE1XkejtOBzWbA2e9gf34OPDWZUXMLepZGQyFu69NCFLe4kY',
          'redirectURL': '/content/JornadasDeCaptacion',
          'idWebSafeShortcut': 'ahZzfm9yYWNsZS1zZXJ2aWNlcy12emxhcjILEghTaG9ydGN1dCIkMjFkODUwZjYtMDRiMi00MDEyLWFkYzgtZjhkNmJhZmNjZGUyDA',
          'order': 3,
          'modificationDate': '2021-07-27T20:36:57.622Z',
          'status': 'A',
          'idCategory': '0'
      },
      {
          'description': 'Programa Cuidamos Tu Salud',
          'imageURL': 'https://lh3.googleusercontent.com/3Ey3kiXy71ajPnc6WK-eoKCcukZ4UE_3ac9MC29WdIC9MVTKfxKrWOQ65DsFnJe_7AiB-H_Bo8H3hIUO88vf6Tr3-5BLHS_2EU0',
          'redirectURL': '/content/CuidamosTuSalud',
          'idWebSafeShortcut': 'ahZzfm9yYWNsZS1zZXJ2aWNlcy12emxhcjILEghTaG9ydGN1dCIkN2E2ZWUxMmQtNWFmZS00YjljLWIzMzQtNjk4MzZkOWU5ZmZkDA',
          'order': 4,
          'modificationDate': '2021-07-27T20:37:06.658Z',
          'status': 'A',
          'idCategory': '0'
      },
      {
          'description': 'Farmatodo a Domicilio',
          'imageURL': 'https://lh3.googleusercontent.com/JL1HyOu5cBnrwgW7HzDv4RrGtWTG0d_Z03jOfXIIFLzQbfZx_6sPcPFsEFQk9uHCVbB0U-642al_MjSBWRSqMRLpbSICHCD54A',
          'redirectURL': '/content/DomiciliosFtdo',
          'idWebSafeShortcut': 'ahZzfm9yYWNsZS1zZXJ2aWNlcy12emxhcjILEghTaG9ydGN1dCIkYzU5NGJmZWEtNzY0Zi00NWZiLWJmYzktNmU1ZDI3ZDlkY2ZiDA',
          'order': 5,
          'modificationDate': '2021-07-27T20:37:15.697Z',
          'status': 'A',
          'idCategory': '0'
      },
      {
          'description': 'Asesoría Farmacéutica en línea',
          'imageURL': 'https://lh3.googleusercontent.com/q9K2uEke5gFhQAl8TNA4Oe75g0L2ZGc-VlxA2HOEEwXbe5XU05RR5MA0YbpHI3g3QRyCc2dJAN2WYbQcJa07YEZ4Qya-YJk98EFCT4oBNArhKYo',
          'redirectURL': '/content/0800Farmatodo',
          'idWebSafeShortcut': 'ahZzfm9yYWNsZS1zZXJ2aWNlcy12emxhcjILEghTaG9ydGN1dCIkMjNkYzU1OTAtOThmNS00ODJmLTgwYzItYmYyMzg1YTE3MmE0DA',
          'order': 6,
          'modificationDate': '2021-07-27T20:37:23.753Z',
          'status': 'A',
          'idCategory': '0'
      },
      {
          'description': 'Fórmulas Magistrales',
          'imageURL': 'https://lh3.googleusercontent.com/dJaMVlMx1d0N38uVCdRNXBoEy3wUYBkGUK3pAFpID9n_ErDp_yXKDR56ZDfik6X-SyMKoIENtNwNFcHcvoHXCt-Y1bUlgjK-sQ',
          'redirectURL': '/content/FormulasMagistrales',
          'idWebSafeShortcut': 'ahZzfm9yYWNsZS1zZXJ2aWNlcy12emxhcjILEghTaG9ydGN1dCIkMzVlOTY5NTAtZjY4YS00Y2VmLTlmMGEtY2Y0ZTQxMTMwMzE4DA',
          'order': 7,
          'modificationDate': '2021-07-27T20:34:47.767Z',
          'status': 'A',
          'idCategory': '0'
      },
      {
          'description': 'Ubicar Farmacias',
          'imageURL': 'https://lh3.googleusercontent.com/82Hnq-F6Yl48_R8c4iM2GaO1a7bMNzbEjoEO60hcLWWpUod-MTr9AfF0j8AVserLdv0eJyeKMdI_0Bq6RdvTG_1gymQcoyS97g',
          'redirectURL': '/tiendas',
          'idWebSafeShortcut': 'ahZzfm9yYWNsZS1zZXJ2aWNlcy12emxhcjILEghTaG9ydGN1dCIkN2ZkNTQzOGQtZDUwZi00YTBkLTkzODItZWQ0OTNkNTQxMTg4DA',
          'order': 8,
          'modificationDate': '2021-07-27T20:37:31.455Z',
          'status': 'A',
          'idCategory': '0'
      },
      {
          'description': 'Servicio Salud Visual',
          'imageURL': 'https://lh3.googleusercontent.com/2FkFskHkolHtGXUJd96Ug-ol8thSO0k5j5tHCzqo-5FyuCb9Fnh1FiNYxKwKB6F3JQdQiFcq5dPz_B6crEuPSleqfzzyCMXXg0eE',
          'redirectURL': '/content/SaludVisual',
          'idWebSafeShortcut': 'ahZzfm9yYWNsZS1zZXJ2aWNlcy12emxhcjILEghTaG9ydGN1dCIkMmU2MWJhNGYtNjg0ZS00YzFjLWI4NTEtYzZkNzk0ZTU3MDEyDA',
          'order': 9,
          'modificationDate': '2021-07-27T20:35:09.706Z',
          'status': 'A',
          'idCategory': '0'
      },
      {
          'description': 'Bebidas',
          'imageURL': 'https://lh3.googleusercontent.com/hBSjWMlVOcc2lTu2hVznobt2YWwvbcMF0jb4YZkUIyqZQt6uJk-I59KvrrZQg0bcVSCljZlXW34rRoy978a-mz_2jtVEHibee97-DsMZ08CE6FM',
          'redirectURL': 'https://www.farmatodo.com.ve/buscar?product=nestea&departamento=Todos&filtros=',
          'idWebSafeShortcut': 'ahZzfm9yYWNsZS1zZXJ2aWNlcy12emxhcjILEghTaG9ydGN1dCIkYTYxY2EwZDItNjI0NS00MjI1LTgyYTEtMzUwMTQ4NWQzYWU3DA',
          'order': 10,
          'modificationDate': '2021-06-29T15:19:27.850Z',
          'status': 'A',
          'idCategory': '0'
      },
      {
          'description': 'Requisito de Récipe Médico',
          'imageURL': 'https://lh3.googleusercontent.com/lhXpWJZvP6ixIdJkc9vnr4KCueTQfG35Pv6ot8oy3Mvm6ujUO9RynvQx154Fg5B1KsofGzDkQn3T0kqymhHDwH9vS6LBGitVVzId',
          'redirectURL': '/content/RequisitosDeRecipes',
          'idWebSafeShortcut': 'ahZzfm9yYWNsZS1zZXJ2aWNlcy12emxhcjILEghTaG9ydGN1dCIkZTBlZTBhZTUtNmY2Yi00MjZjLWI1MTQtOGE1ZTJkNzkwZmYzDA',
          'order': 10,
          'modificationDate': '2021-07-27T20:37:41.409Z',
          'status': 'A',
          'idCategory': '0'
      },
      {
          'description': 'Medicamentos',
          'imageURL': 'https://lh3.googleusercontent.com/2pvU5j0DfQdOcPo-HdVmKwfpMI6tAxnrUawe7GEfhxZQ4ipxm78jqMf9fnW4HIMM5EFfR2i-dQVPiN-bIc0CSqQgzQpi2pGWEoK1cuXHYKAiddWBEw',
          'redirectURL': 'https://www.farmatodo.com.ve/categorias/salud-y-medicamentos',
          'idWebSafeShortcut': 'ahZzfm9yYWNsZS1zZXJ2aWNlcy12emxhcjILEghTaG9ydGN1dCIkNGJiZjJhNzctNTFhOS00YzE0LWJkNTUtODM2MzlkODJjYTc4DA',
          'order': 11,
          'modificationDate': '2021-07-08T14:16:11.470Z',
          'status': 'A',
          'idCategory': '0'
      },
      {
          'description': 'Alimentos',
          'imageURL': 'https://lh3.googleusercontent.com/iAuWP13kJ8f3tAqMB93jv5S8GqMDWPixKfRMud1v6y9GI4d23D7yLltqBf6pxUGlF1vcPo0UY07mIiwqW4tCPhp3nXq0ikxXoTSjaUm40BomD2_lXA',
          'redirectURL': 'https://www.farmatodo.com.ve/categorias/alimentos-y-bebidas/alimentos',
          'idWebSafeShortcut': 'ahZzfm9yYWNsZS1zZXJ2aWNlcy12emxhcjILEghTaG9ydGN1dCIkYjgzZTg0ZmQtNTA1NC00YjMyLTk2MjEtY2YzM2MwMTQ5MThlDA',
          'order': 12,
          'modificationDate': '2021-07-08T14:20:36.575Z',
          'status': 'A',
          'idCategory': '0'
      },
      {
          'description': 'Desodorantes',
          'imageURL': 'https://lh3.googleusercontent.com/VHFLdmv-IguUBaYIrhZgoozuLgjj-IJvcSiBSAPs9HjPCHOj0YBX3q-xEsF7W_0poc-3Lug-qBktd9zQhXKd3ZsYyjCP0ST-8BPmai4DO1Wpe5WF',
          'redirectURL': 'https://www.farmatodo.com.ve/categorias/cuidado-personal/higiene-personal/desodorantes',
          'idWebSafeShortcut': 'ahZzfm9yYWNsZS1zZXJ2aWNlcy12emxhcjILEghTaG9ydGN1dCIkY2E3NjQ3NTctMGJkNy00ZDI4LTkwMjgtNDhiMjUwYjk3YTU4DA',
          'order': 13,
          'modificationDate': '2021-05-18T13:25:04.027Z',
          'status': 'A',
          'idCategory': '0'
      },
      {
          'description': 'Nutrición - Bebé',
          'imageURL': 'https://lh3.googleusercontent.com/MkkJRPPoTFsVtz9ySPtgdf84O-VuSxAbxIvOB9rmhrbCSc7pqLrpOVR3JVXsLFnQ-TZIhJ7rCOx3mw6EeNrvMI7QSmL_5WOv60YD_1EX61Q1zrGIJQ',
          'redirectURL': 'https://www.farmatodo.com.ve/destacados/3454',
          'idWebSafeShortcut': 'ahZzfm9yYWNsZS1zZXJ2aWNlcy12emxhcjILEghTaG9ydGN1dCIkOWZhYWViNmQtNmFjMC00YmM2LTg2ZDYtMTcwMWJkNTkxYmUyDA',
          'order': 14,
          'modificationDate': '2021-07-08T14:30:43.811Z',
          'status': 'A',
          'idCategory': '0'
      },
      {
          'description': 'Vitaminas C',
          'imageURL': 'https://lh3.googleusercontent.com/kY6Rem2XJJvj1YsyK-1V0mXNAxipGnBQBoM830p-aFyQwxQvrFUZ6oxQtzOdXGsDuqbWcZK4l_iZmtMnprqC1i-MsXDW2kC7aRLindFIJfGazHpUxg',
          'redirectURL': 'https://www.farmatodo.com.ve/categorias/salud-y-medicamentos/vitaminas-y-productos-naturales/vitamina-c-',
          'idWebSafeShortcut': 'ahZzfm9yYWNsZS1zZXJ2aWNlcy12emxhcjILEghTaG9ydGN1dCIkYjljNDQ2YjYtOTZiZC00Y2E0LWFjNTctOTBkYmYyNDIyOTM1DA',
          'order': 14,
          'modificationDate': '2021-05-18T13:25:20.451Z',
          'status': 'A',
          'idCategory': '0'
      },
      {
          'description': 'Medicamentos Oncológicos y Especializados',
          'imageURL': 'https://lh3.googleusercontent.com/RyjtLHidXrnr5fJ5ru0Q6KSnqo-CIMGQneGxZfROCYV7ur8-0EGPibfqhUGaWAgOfFiNJsvI0NikITAwfNohWLJ-MwN-TJy-1DhB',
          'redirectURL': '/sugeridos/982',
          'idWebSafeShortcut': 'ahZzfm9yYWNsZS1zZXJ2aWNlcy12emxhcjILEghTaG9ydGN1dCIkZjBlNzU5NmQtYTUyOS00MzczLWJhNjQtYTE2MDMzNjJjZWM3DA',
          'order': 14,
          'modificationDate': '2021-07-27T20:37:48.778Z',
          'status': 'A',
          'idCategory': '0'
      },
      {
          'description': 'Antimigrañosos',
          'imageURL': 'https://lh3.googleusercontent.com/z51f6AsuA0rO1mitQEcXQxHeIAokiGLus3zguasqs8ZAVy5-BBDHC153B4Y7Xixn1ZnoL9tZDIXCEJ5qCqQCgy9CctI7FVhK0zAsYXOnQvpYmwDdOQ',
          'redirectURL': 'https://www.farmatodo.com.ve/categorias/salud-y-medicamentos/dolor-general/antimigranosos',
          'idWebSafeShortcut': 'ahZzfm9yYWNsZS1zZXJ2aWNlcy12emxhcjILEghTaG9ydGN1dCIkMDg0N2FiODMtODc2Yy00YzkxLTk0ZTktMGE1MjljOGQwYzgzDA',
          'order': 15,
          'modificationDate': '2021-07-08T22:04:18.429Z',
          'status': 'A',
          'idCategory': '0'
      },
      {
          'description': 'Crema Dental',
          'imageURL': 'https://lh3.googleusercontent.com/Edf-6FvzJOVrc90E-KDmGQvILxCIeDGYUv19tIQn3eZaa06OF69kU3_xE1vMdaCoeZdHBEZIDL4Ruzn-qn395eULyrWChUxfZz1FQsnAIMIlJQcH',
          'redirectURL': 'https://www.farmatodo.com.ve/categorias/cuidado-personal/cuidado-bucal/cremas-dentales',
          'idWebSafeShortcut': 'ahZzfm9yYWNsZS1zZXJ2aWNlcy12emxhcjILEghTaG9ydGN1dCIkNDdlZThmNzAtOWJiYS00ZjY2LTg2MTktM2U4MmRkMzVlMjE1DA',
          'order': 15,
          'modificationDate': '2021-05-18T13:25:26.681Z',
          'status': 'A',
          'idCategory': '0'
      },
      {
          'description': 'Belleza',
          'imageURL': 'https://lh3.googleusercontent.com/0vmur8OB3KRmfPOGzkZT6xXBQLipzgUkXK4k1OZHYcB4eOTRCv2__o2synIZPGe8NwoDOEOlvevcq4g_DV3X_FQac-rk61FD1g',
          'redirectURL': '/categorias/belleza/cosmeticos',
          'idWebSafeShortcut': 'ahZzfm9yYWNsZS1zZXJ2aWNlcy12emxhcjILEghTaG9ydGN1dCIkODNlODMyNGYtMTRiZC00MGVhLTk2YTEtMDEzZTcxYmIzZjUzDA',
          'order': 15,
          'modificationDate': '2021-07-27T20:37:58.524Z',
          'status': 'A',
          'idCategory': '0'
      },
      {
          'description': 'Medicamentos',
          'imageURL': 'https://lh3.googleusercontent.com/4OFBI609Ez63w4k2bdCaVnSF4WMnyfHqney-nejCqrMm803XlvK5q7HfhssTJziVsAThChaE1OUk8UzrA6-t_fD-hQQO5II6iN2JOthRsengN10',
          'redirectURL': 'https://www.farmatodo.com.ve/categorias/salud-y-medicamentos/medicamentos',
          'idWebSafeShortcut': 'ahZzfm9yYWNsZS1zZXJ2aWNlcy12emxhcjILEghTaG9ydGN1dCIkMTE2MjBmYzQtYmVmMS00N2ZhLThiZTctOTU0NTk1YmQ2MmNiDA',
          'order': 16,
          'modificationDate': '2021-07-11T00:12:43.386Z',
          'status': 'A',
          'idCategory': '0'
      },
      {
          'description': 'Bebidas en Polvo',
          'imageURL': 'https://lh3.googleusercontent.com/bvnGC8idMqXjAYxNK2YKKgRT1aaN-_K-IC2yP8SwYlbG3cEyFRT2aS2D4CPFwWqwLwPCUCSxKoqKR5H-P_ieU53evZvZpI5QgsTT3ZZp5rvZ794y',
          'redirectURL': 'https://www.farmatodo.com.ve/producto/112971354-leche-svelty',
          'idWebSafeShortcut': 'ahZzfm9yYWNsZS1zZXJ2aWNlcy12emxhcjILEghTaG9ydGN1dCIkZGFhYjA3NzgtYjU5Yi00MTM4LWEwMjEtZmRjZmUxZWQyNDFiDA',
          'order': 18,
          'modificationDate': '2021-06-01T18:47:17.006Z',
          'status': 'A',
          'idCategory': '0'
      },
      {
          'description': 'Cuidado del bebé',
          'imageURL': 'https://lh3.googleusercontent.com/155_z703KsVfvyJ8Yy84r0P9o6CreJcOyrwzKoetabESGx04Da62qucfAMwR3yeuCGB1V3CRjh58v1Pk-TiujyHArZiYnDwou7ZA',
          'redirectURL': 'https://www.farmatodo.com.ve/categorias/bebe/higiene-del-bebe',
          'idWebSafeShortcut': 'ahZzfm9yYWNsZS1zZXJ2aWNlcy12emxhcjILEghTaG9ydGN1dCIkMmM2YWNmZmUtNTgwYy00NTUxLWFjMzEtNzM2MGU1ODgxNmRmDA',
          'order': 20,
          'modificationDate': '2021-05-18T13:25:49.875Z',
          'status': 'A',
          'idCategory': '0'
      },
      {
          'description': 'Cuidado Personal',
          'imageURL': 'https://lh3.googleusercontent.com/yUTT-tindFxlqwS2d0rRmKnRFX9uRPQrckw5FyKIikdJ7_f4CFX0HK9Fw9jF0OjJGwuvCLsaVwdIAqlrnI5d_SD2HSvm52UQkls',
          'redirectURL': '/categorias/cuidado-personal/higiene-personal',
          'idWebSafeShortcut': 'ahZzfm9yYWNsZS1zZXJ2aWNlcy12emxhcjILEghTaG9ydGN1dCIkNTJmMjllMTktZmZkZS00NDBlLWJmN2QtMDk0NmEzZTQzNzAxDA',
          'order': 21,
          'modificationDate': '2021-07-27T20:35:46.511Z',
          'status': 'A',
          'idCategory': '0'
      },
      {
          'description': 'Cardiovascular',
          'imageURL': 'https://lh3.googleusercontent.com/GR84aWlYuKj_9NOluETtNgCsOHKdkkIQJ4JtCcREzm3z1E74W4lQ0KqyEFWWRFP3yBFZ2f5EkUdlC_oPverM25_c39Kt7vmZlJLpe2cyFjrhe0cF',
          'redirectURL': '/sugeridos/1257',
          'idWebSafeShortcut': 'ahZzfm9yYWNsZS1zZXJ2aWNlcy12emxhcjILEghTaG9ydGN1dCIkOGYxNzMxMDgtYTg1ZC00YmNkLTg5YmUtMjdhZmY2MmVjZWEyDA',
          'order': 27,
          'modificationDate': '2021-07-27T20:35:55.246Z',
          'status': 'A',
          'idCategory': '0'
      },
      {
          'description': 'Envíalo Ya',
          'imageURL': 'https://lh3.googleusercontent.com/jR1VofHnw6C3FgX94eXtzy30oMeVihj1hZnWAVl9DLqselc4O3-ROrx9nxadkeGspv-aXEMqYVaCbR-R9cODR6KpXmQ9YGMVYwjo',
          'redirectURL': 'https://www.farmatodo.com.co/envialo-ya',
          'idWebSafeShortcut': 'ahZzfm9yYWNsZS1zZXJ2aWNlcy12emxhcjILEghTaG9ydGN1dCIkMGY3YWQzMDYtZTE0MS00OTZkLTllYTQtZDg3MGE5ZDNlOGE0DA',
          'order': 32,
          'modificationDate': '2021-07-27T20:36:03.105Z',
          'status': 'A',
          'idCategory': '0'
      }
  ]
  }
};
